import { Experiments } from 'constants/optimizely'
import useExperiment from 'hooks/Optimizely/useExperiment'

export type AccommodationStickyFooterCtaMode = 'checkAvailability' | 'selectRoom' | 'selectPackage' | 'selectRooms'

interface Options {
  availableForPurchase?: boolean
  canShowCheckAvailabilityCta: boolean
  canShowPackageSelectCta: boolean
  canBookNowMultiRoom?: boolean
  gateCheckAvailabilityCtaByExperiment?: boolean
  room?: App.PackageRoomType
  useMultiRoomSelectRoomsCta?: boolean
}

function useMobilePackageSelectCtaExperimentState(options: Options) {
  const {
    availableForPurchase,
    canShowCheckAvailabilityCta,
    canShowPackageSelectCta,
    canBookNowMultiRoom,
    gateCheckAvailabilityCtaByExperiment,
    room,
    useMultiRoomSelectRoomsCta,
  } = options

  const canActivatePackageSelectCtaExperiment =
    !!availableForPurchase &&
    canShowPackageSelectCta &&
    (!canBookNowMultiRoom || !!useMultiRoomSelectRoomsCta)
  const canActivateCheckAvailabilityCtaExperiment =
    !!availableForPurchase &&
    canShowCheckAvailabilityCta &&
    !!gateCheckAvailabilityCtaByExperiment

  const { isAnyVariant } = useExperiment(Experiments.croMobileWebPackageSelectCta, {
    canActivate: canActivatePackageSelectCtaExperiment || canActivateCheckAvailabilityCtaExperiment,
  })

  const showPackageSelectCta = canActivatePackageSelectCtaExperiment && isAnyVariant
  const showMultiRoomSelectRoomsCta = showPackageSelectCta && !!useMultiRoomSelectRoomsCta
  const showCheckAvailabilityCta = canShowCheckAvailabilityCta && (!gateCheckAvailabilityCtaByExperiment || isAnyVariant)
  const shouldMountStickyFooter = showCheckAvailabilityCta || showPackageSelectCta

  let ctaMode: AccommodationStickyFooterCtaMode = 'checkAvailability'
  if (showMultiRoomSelectRoomsCta) {
    ctaMode = 'selectRooms'
  } else if (showCheckAvailabilityCta && useMultiRoomSelectRoomsCta) {
    ctaMode = 'selectRooms'
  } else if (showPackageSelectCta) {
    ctaMode = room ? 'selectPackage' : 'selectRoom'
  }

  return {
    ctaMode,
    showCheckAvailabilityCta,
    showMultiRoomSelectRoomsCta,
    showPackageSelectCta,
    shouldMountStickyFooter,
  }
}

export default useMobilePackageSelectCtaExperimentState
